import { gql } from "graphql-request";
import graphQLClient from 'config/graphql-instance';

export type partiesTypeForm = {
  party_id: string;
  kind: string;
  amount: number;
  at_closing_amount: number;
  before_closing_amount: number;
  at_closing_percent: number;
  before_closing_percent: number;
  partyKinds: string[];
  name: string;
}

export type chargesPayeePayerForm = {
  InvolvedParties: partiesTypeForm[];
  typeAmount: 'Amount' | 'Percent';
}

export type HelpOrderLedgerEntryPartiesReturn = {
  helpOrderLedgerPayeePay: {
    _id: string;
  };
};

export type OrderEntryPartyContent = {
  amount?:number;
  at_closing_amount?:number;
  at_closing_percent?: number;
  before_closing_amount?: number;
  before_closing_percent?: number;
  kind: string;
  party_id:string;
  percent?: number
}

export type HelpOrderLedgerEntryPartiesPayload = {
  id: string,
  data:{
    accounting_id:string,
    parties: OrderEntryPartyContent[]
   }[]
};

export const helpOrderLedgerEntryParties = async (payload:HelpOrderLedgerEntryPartiesPayload) => {
  const mutation = gql`
  mutation HelpOrderLedgerEntryParties($id: ID!, $data: [OrderEntriesContent!]!) {
    helpOrderLedgerEntryParties(_id: $id, data: $data) {
      _id
    }
  }
  `;
  const response = await graphQLClient().request<HelpOrderLedgerEntryPartiesReturn>(
    mutation,
    payload
  );

  return response;
};

export type DeleteOrderLedgerRolePayload = {
  id: string,
  accountingIds: string[],
  role: string
};

export type DeleteOrderLedgerRoleReturn = {
  deleteOrderLedgerRole: {
    _id: string;
  };
};

export const deleteOrderLedgerRole = async (payload: DeleteOrderLedgerRolePayload) => {
  const mutation = gql`
    mutation DeleteOrderLedgerRole($id: ID!, $accountingIds: [ID!]!, $role: String!) {
      deleteOrderLedgerRole(_id: $id, accounting_ids: $accountingIds, role: $role) {
        _id
      }
    }
  `;

  const response = await graphQLClient().request<DeleteOrderLedgerRoleReturn>(
    mutation,
    payload
  );

  return response;
};